import { motion } from "framer-motion";

const stats = [
  { value: "817K+", label: "Investors" },
  { value: "211K+", label: "Active Investors Monthly" },
  { value: "$220M+", label: "Monthly Investing Volume" },
  { value: "$509B+", label: "Withdrawn Each Month" },
];

const CompanyStatsSection = () => {
  return (
    <section className="py-24 bg-card/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
            Trusted by Millions
          </h2>
          <p className="mt-4 text-muted-foreground font-body text-lg">
            Our numbers speak for themselves.
          </p>
        </motion.div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-xl border border-gold-dark/30 bg-card p-8 text-center"
            >
              <p className="font-display text-3xl font-bold gradient-gold-text">{s.value}</p>
              <p className="mt-2 text-sm text-muted-foreground font-body">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyStatsSection;
